import { Dispatch, SetStateAction, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

export interface PhraseContextValue {
  platform: General.PlatformUpperCase;
  region?: General.UpperCaseRegion;
  statistic: Phrase.Statistic;
  platformList: General.PlatformUpperCase[];
  regionList: Util.ElementType<Phrase.Statistic['channelPhraseInfo']>['regionPhraseInfo'];
  setStatistic: Dispatch<SetStateAction<Phrase.Statistic | undefined>>;
  fetchStatistic: () => Promise<Phrase.Statistic | undefined>;
  addStatistic: (
    platform: General.PlatformUpperCase,
    region: General.UpperCaseRegion,
    count: number,
  ) => void;
  groupType: Phrase.Group['groupType'];
}

export const PhraseContext = createNamedContext<PhraseContextValue | null>('PhraseContext', null);

export const usePhraseContext = () => {
  const value = useContext(PhraseContext);

  if (value === null) {
    throw new Error(
      'usePhraseContext should be used in a context of PhraseContext.Provider component.',
    );
  }

  return value;
};
